module.exports = __webpack_public_path__ + "assets/media/bf2042_mian_theme.39a3519a.mp3";